'use strict';

import {EwSiteApp} from "../../app/ewsiteapp.js";
import {ItemPreviewCtrl} from '../../app/previewctrl.js';
import {wpActivityModel} from '../../models/wpactivitymodel.js';
import {wpDeliverableModel} from '../../models/wpdeliverablemodel.js';
import {ewModel} from '../../models/ewmodel.js';

class A41PreviewCtrl extends ItemPreviewCtrl
{
	activities = [];
	deliverables = [];
	
	constructor($mdDialog, $filter, item, options){
		super($mdDialog, $filter, item, options);
		this.setContent(options);
	}
	
	
	setContent(options){
		if(typeof(options.title) !== 'undefined'){
			this.viewOptions.title = options.title;
		}
		else{
			this.viewOptions.title = this.$filter('tr')('preview_title');
		}
		if(this.item instanceof ewModel){
			this.viewOptions.type = 'ewmodel';
		}
		
		this.getParticipantField = function(id, field){
			return options.participantField(id, field);
		};
		
		if(typeof(this.item.activities) !== 'undefined'){
			for(let activ in this.item.activities){
				this.activities.push(new wpActivityModel(this.item.activities[activ], options.$filter, options.jsDataService));
			}
		}
		
		if(typeof(this.item.deliverables) !== 'undefined'){
			for(let dlvr in this.item.deliverables){
				this.deliverables.push(new wpDeliverableModel(this.item.deliverables[dlvr], options.$filter, options.jsDataService));
			}
		}
	}
}

EwSiteApp.controller('A41PreviewCtrl', ["$mdDialog", "$filter", "item", "options", A41PreviewCtrl]);